module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel1-en-GB@3x-d2178e0775134d5f0f9b6df922396bf6.png";